import { useForm } from "react-hook-form"
import { Link, useNavigate, useSearchParams } from "react-router"
import { api, ApiError } from "../../lib/api"
import { useAuthRedirect } from "../../hooks/useAuthRedirect"
import OAuthButtons from "../../components/OAuthButtons"
import appName from "../../lib/appName"
import "../../styles/auth.scss"

type FormValues = {
  email: string
  password: string
}

export default function LoginPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const redirect = searchParams.get("redirect")
  const authStatus = useAuthRedirect(redirect || "/")

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm<FormValues>()

  const onSubmit = async (data: FormValues) => {
    try {
      await api.post("/users/sign_in", { user: data })
      navigate(redirect || "/")
    } catch (err) {
      const { data: errData } = err as ApiError
      if (errData.redirect) {
        navigate(errData.redirect)
      } else {
        setError("root", {
          message: errData.error ?? "メールアドレスまたはパスワードが正しくありません",
        })
      }
    }
  }

  if (authStatus === "loading") return null

  return (
    <div className="auth-layout">
      <div className="auth-card">
        <div className="auth-logo">
          <img src="/logo.png" alt={appName()} className="auth-logo__img" />
        </div>

        <h1 className="auth-title">ログイン</h1>
        <p className="auth-subtitle">アカウントにサインインしてください</p>

        <OAuthButtons action="ログイン" redirect={redirect} />

        <div className="divider"><span>または</span></div>

        {errors.root && (
          <div className="error-banner">{errors.root.message}</div>
        )}

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
            <label>メールアドレス</label>
            <input
              type="email"
              placeholder="test@example.com"
              className={errors.email ? "error" : ""}
              {...register("email", { required: "メールアドレスを入力してください" })}
            />
            {errors.email && <p className="field-error">{errors.email.message}</p>}
          </div>

          <div className="form-group">
            <label>パスワード</label>
            <input
              type="password"
              placeholder="パスワードを入力"
              className={errors.password ? "error" : ""}
              {...register("password", { required: "パスワードを入力してください" })}
            />
            {errors.password && <p className="field-error">{errors.password.message}</p>}
            <div style={{ textAlign: "right", marginTop: 6 }}>
              <Link to="/forgot-password" style={{ fontSize: 13, color: "#FF9100", textDecoration: "none" }}>
                パスワードをお忘れですか？
              </Link>
            </div>
          </div>

          <button type="submit" className="btn-primary" disabled={isSubmitting}>
            {isSubmitting ? "ログイン中..." : "ログイン"}
          </button>
        </form>

        <div className="auth-footer">
          アカウントをお持ちでないですか？ <Link to={redirect ? `/signup?redirect=${encodeURIComponent(redirect)}` : "/signup"}>新規登録</Link>
        </div>
      </div>
    </div>
  )
}
